import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ChartModule } from 'primeng/chart';
import { ChatAiRoutingModule } from './chat-ai-routing.module';
import { ChatActionCardComponent } from './components/chat-action-card/chat-action-card.component';
import { ChatConversationComponent } from './components/chat-conversation/chat-conversation.component';
import { ChatDrawerComponent } from './components/chat-drawer/chat-drawer.component';
import { ChatInputComponent } from './components/chat-input/chat-input.component';
import { ChatMessageComponent } from './components/chat-message/chat-message.component';
import { ChatMiniChartComponent } from './components/chat-mini-chart/chat-mini-chart.component';
import { ChatPageComponent } from './components/chat-page/chat-page.component';
import { ChatSidebarComponent } from './components/chat-sidebar/chat-sidebar.component';
import { ChatProductCardComponent } from './components/chat-product-card/chat-product-card.component';
import { ChatSuggestionsComponent } from './components/chat-suggestions/chat-suggestions.component';
// Agent Hub
import { AgentBadgeComponent } from './components/agent-badge/agent-badge.component';
import { AgentCardComponent } from './components/agent-card/agent-card.component';
import { AgentDirectoryComponent } from './components/agent-directory/agent-directory.component';
import { ChatOnboardingGuideComponent } from './components/chat-onboarding-guide/chat-onboarding-guide.component';
import { ChatFinancialReportComponent } from './components/chat-financial-report/chat-financial-report.component';
import { ChatKpiTilesComponent } from './components/chat-kpi-tiles/chat-kpi-tiles.component';

@NgModule({
  declarations: [
    ChatActionCardComponent,
    ChatConversationComponent,
    ChatDrawerComponent,
    ChatInputComponent,
    ChatMessageComponent,
    ChatMiniChartComponent,
    ChatPageComponent,
    ChatProductCardComponent,
    ChatSidebarComponent,
    ChatSuggestionsComponent,
    // Agent Hub
    AgentBadgeComponent,
    AgentCardComponent,
    AgentDirectoryComponent,
    ChatOnboardingGuideComponent,
    ChatFinancialReportComponent,
    ChatKpiTilesComponent,
  ],
  imports: [CommonModule, FormsModule, RouterModule, TranslateModule, ChartModule, ChatAiRoutingModule],
  exports: [ChatDrawerComponent],
})
export class ChatAiModule {}
